import { apiFetch } from "../client"

export interface ServiceHealth {
  name: string
  category: string
  status: string
  latencyMs: number
  metrics?: Record<string, unknown>
  lastChecked: string
}

export interface CronJobHealth {
  name: string
  schedule: string
  lastRunAt: string | null
  status: string
  successRate24h: number | null
}

export interface RecentFailure {
  type: string
  count: number
  lastAt: string | null
}

export interface FailedJobSummary {
  openCount: number
  retryableCount: number
  lastFailureAt: string | null
}

export interface BackupHistoryRow {
  backupDate: string
  status: string
  storageKey: string | null
  fileSize: number | null
  attemptedAt: string
  completedAt: string | null
  errorMessage: string | null
}

export interface BackupStatusHealth {
  status: string
  lastSuccessAt: string | null
  lastFailureAt: string | null
  lastStorageKey: string | null
  history: BackupHistoryRow[]
}

export interface SystemAlertHealth {
  alertId: string
  alertKey: string
  severity: string
  title: string
  body: string
  resourceType: string | null
  resourceId: string | null
  createdAt: string
}

export interface FailedJobHealth {
  failureId: string
  triggerKey: string
  executionId: string
  entityType: string | null
  entityId: string | null
  retryable: boolean
  errorCode: string | null
  errorMessage: string
  dispositionStatus: string
  retryCount: number
  createdAt: string
  payloadJson: Record<string, unknown> | null
  sourceMessageJson: Record<string, unknown> | null
}

export interface SystemHealthReport {
  overallStatus: "operational" | "degraded" | "critical"
  services: ServiceHealth[]
  cronJobs: CronJobHealth[]
  recentFailures: RecentFailure[]
  failedJobsSummary: FailedJobSummary
  backupStatus: BackupStatusHealth
  activeAlerts: SystemAlertHealth[]
  checkedAt: string
}

export function getSystemHealth() {
  return apiFetch<{ data: SystemHealthReport }>("/system-health")
}

export function listFailedJobs() {
  return apiFetch<{ data: FailedJobHealth[] }>("/system-health/failed-jobs")
}

export function retryFailedJob(failureId: string) {
  return apiFetch<{ data: { retried: boolean } }>(`/system-health/failed-jobs/${failureId}/retry`, {
    method: "POST",
  })
}

export function discardFailedJob(failureId: string) {
  return apiFetch<{ data: { discarded: boolean } }>(
    `/system-health/failed-jobs/${failureId}/discard`,
    {
      method: "POST",
    },
  )
}
